// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconStar = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M59.2382 25.9699L47.3639 36.8789C46.7901 37.406 46.6048 37.9765 46.7591 38.7402L49.9536 54.545C50.3312 56.413 48.6827 57.6107 47.0228 56.6743L32.9786 48.7523C32.3 48.3695 31.7 48.3695 31.0214 48.7523L16.9772 56.6743C15.3173 57.6107 13.6688 56.413 14.0464 54.545L17.2409 38.7402C17.3952 37.9765 17.2099 37.406 16.6361 36.8789L4.7618 25.9699C3.35837 24.6806 3.98804 22.7427 5.88128 22.5246L21.8998 20.6787C22.6738 20.5895 23.1591 20.2369 23.4831 19.5284L30.1887 4.86432C30.9812 3.13116 33.0188 3.13116 33.8113 4.86432L40.5169 19.5284C40.8409 20.2369 41.3262 20.5895 42.1002 20.6787L58.1187 22.5246C60.012 22.7427 60.6416 24.6806 59.2382 25.9699Z" />
    </svg>
  );
};
